<template>
    <div class="viewpoints-wrap">
        <Title v-if="page">
            <h2><router-link to="/news" id="news-page">News</router-link></h2>
        </Title>
        <div class="page-inner">
            <div class="list" v-if="posts.length !== 0">
                <Item
                    v-for="(item, index) in posts"
                    :key="item.id + '-' + index"
                    :item="item"
                />
            </div>
            <Loading v-if="$store.state.is_loading" class="static" />
            <NoResults v-if="posts.length === 0 && !$store.state.is_loading">
                No posts ...
            </NoResults>
        </div>
    </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import NoResults from "@/components/ui/NoResults.vue";
import Item from "@/components/Item2.vue";
import Loading from "@/components/Loading.vue";

export default {
    name: "news",

    data() {
        return {
            page: false,
            posts: [],
            categories: [],
            paged: 1,
            per_page: 999,
            is_end: false
        };
    },

    components: {
        Title,
        Item,
        Loading,
        NoResults
    },

    watch: {
        "$route.params": {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true
        }
    },

    methods: {
        getPosts(is_next = false) {
            if (!is_next) {
                this.paged = 1;
                this.posts = [];
                this.is_end = false;
            } else if (this.is_end) return;
            else this.paged++;

            this.$store.state.is_loading = true;

            let url = `get-news?per_page=${this.per_page}&paged=${this.paged}`;

            this.$ajax
                .get(url)
                .then(res => {
                    if (is_next) {
                        res.data.forEach(item => {
                            this.posts.push(item);
                        });
                    } else {
                        this.posts = res.data;
                    }

                    this.$store.state.is_loading = false;
                    this.is_end = res.data.length < this.per_page;
                })
                .catch(error => {
                    // console.log(error)
                    this.is_end = true;
                });
        },

        fetchData(params) {
            this.page = false;
            // this.current_page_id = false;

            this.$ajax.get("pages?slug=news").then(res => {
                this.page = res.data[0];

                document.title =
                    window.globals.site_title +
                    " — " +
                    this.$decode(res.data[0].title.rendered);
            });

            this.getPosts();
        }
    }
};
</script>

<style lang="scss">
.list {
    margin: 0 var(--margin);
}
.page-news {
    .load-more {
        padding-top: var(--padding-x2);
    }
}
</style>
